export default "__VITE_ASSET__B229lwi8__"